import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ExclamationCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/ExclamationCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExclamationCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ExclamationCircleOutlined.displayName = 'ExclamationCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(ExclamationCircleOutlined);